import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import autoBind from 'react-autobind'
import { withRouter } from 'react-router';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import { fetchOverlays, clearOverlayErrors } from '../actions'
import ShowOverlays from '../components/overlays/ShowOverlays'
import Pagination from '../components/home/Pagination'
import TextField from 'material-ui/TextField'
import { cyan900 } from 'material-ui/styles/colors'


const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  overlays: PropTypes.any,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
}

class OverlaysPage extends React.Component {
  constructor(){
    super();
    autoBind(this);
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount(){
    this.props.dispatch(clearOverlayErrors());
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    const query = this.props.query;
    const router = this.props.router;
    if (this.props.overlays && this.props.overlays.search && this.props.overlays.search.length > 0) {
      query.search = this.props.overlays.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/overlays', query });
    } else {
      this.props.dispatch(fetchOverlays(query));
    }
  }
  handleSearchChange(e) {
    const overlays = this.props.overlays;
    const query = this.props.query;
    const router = this.props.router;
    const nextOverlay = e.target.value;
    overlays.search = nextOverlay;
    // this.setState({
    //   overlays,
    // });
    if (nextOverlay.length > 0) {
      query.search = nextOverlay;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/overlays', query });
    this.props.dispatch(fetchOverlays(query));
  }
  navigation(route) {
    this.props.dispatch(fetchOverlays(route));
  }
  render() {
    console.log('Overlays --->', this.props.overlays)
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    }
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    }
    return (
      <div className="settings component" style={authPage}>
        <h2>Overlays</h2>
        <div className="action-buttons top" style={{width: '100%', padding: '0px 20px'}}>
            <TextField
              floatingLabelText="Search by Overlay"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.overlays.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.overlays.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
        <ShowOverlays 
          overlays={this.props.overlays}
        />
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.overlays.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}


OverlaysPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OverlaysPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    overlays: state.overlays,
    query: ownProps.location.query,
  };
}
export default withRouter(connect(mapStateToProps)(OverlaysPage));



// WEBPACK FOOTER //
// ./src/containers/OverlaysPage.js